import { useBreakpoint } from '@glow/ui-components'
import Menu, { MenuProps } from '../../trackdelivery/components/Menu'
import { Logo } from './Logo'

interface HeaderProps extends MenuProps {
  homeUrl?: string
}

const Header = (props: HeaderProps) => {
  const isDesktop = useBreakpoint('lg')
  return (
    <>
      {!isDesktop ? (
        <header className="o-mobil">
          <div className="top-navigation">
            <div className="logotype">
              <Logo homeUrl={props.homeUrl} />
            </div>
          </div>
          {props.activeHeader !== 'hidden' && (
            <nav className="o-bottom-navigation">
              <div className="inner">
                <Menu {...props} />
              </div>
            </nav>
          )}
        </header>
      ) : (
        <header className="o-desktop">
          <nav className="desktop-navigation no-desktop-main-navigation flex items-center justify-between">
            <Logo homeUrl={props.homeUrl} />
            {isDesktop && <Menu {...props} />}
          </nav>
        </header>
      )}
    </>
  )
}

export default Header
